import { DataSecurityMonitorType } from '@sonar-software/sonar-core';
import { enumNumericValues } from '@sonar-software/sonar-ts-lib';
import React from 'react';
import { SonarText } from '@ui/text';
import { COPY_SPECIFIC, PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import { monitorParentType, monitorTypeLabel, MonitorTypeTag } from './MonitorTypeTag';
import { Select, Space } from 'antd';
const monitorTypeOptions = enumNumericValues(DataSecurityMonitorType)
    .filter((type) => monitorParentType[type] === undefined ||
    monitorParentType[type] === type)
    .map((value) => ({
    label: React.createElement(MonitorTypeTag, { monitorTypeId: value }),
    value
}));
export const MonitorTypeFilter = ({ onTypeSelect }) => React.createElement(Space, { direction: 'vertical' },
    React.createElement(SonarText, null, COPY_SPECIFIC.TYPE),
    React.createElement(Select, { allowClear: true, className: 'type-select', filterOption: (input, option) => {
            if (!input || !option) {
                return true;
            }
            const label = monitorTypeLabel[option.value];
            if (!label) {
                return true;
            }
            return label.toLowerCase().includes(input.toLowerCase());
        }, onChange: onTypeSelect, options: monitorTypeOptions, placeholder: PLACEHOLDERS_COPY.FILTER_BY(COPY_SPECIFIC.TYPE), showSearch: true }));
